import React from "react";
import { StyledH2 } from "@aureskonnect/react-ui";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { DynamicTable } from "@maherunlocker/custom-react-table";
import classnames from "classnames";
import { useSnapshot } from "valtio";

import { capitalize } from "../../helpers/general";

import { store } from "../../components/VerticalLayout/store";
import { store as storeData } from "../../store/project/index";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import CustomColumnDisplay from "@components/Common/CustomColumnDisplay";
import { useAuthHeader } from "../../api/headersKeycloak";
import { HISTORY_I18N_KEY } from "@constants/index";
import { useHistoryColumns } from "./HistoryModalColumns";

export default function HistoryModal({
    isModalOpened,
    setIsModalOpened,
    setIsDataUpdated,
    setIsCreatedProject,
    setSelectedRows,
}: any) {
    const { t } = useTranslation();
    const getAuthHeader = useAuthHeader();

    const { selectedProject } = useSnapshot(storeData);
    const { franchiseID, userID } = useSnapshot(store);

    const [dataIsUpdated, setDataIsUpdated] = React.useState<boolean | number>(
        false
    );
    const [, setArrayIds] = React.useState<any[]>([]);
    const [data, setData] = React.useState<any>({});
    const [filterActive, setLocalFilterActive] = React.useState<boolean>(false);
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const ActionColumn = (e: any) => {
        return e.selectedRow.subRows === undefined ? <div></div> : null;
    };
    const url = `${
        process.env.REACT_APP_API_V2_URL
    }/settings/general/project/history?userId=${userID}&franchiseId=${franchiseID}&project=${selectedProject
        .map((el: any) => JSON.stringify(el))
        .join()}`;

    const arrayOfCustomColumns = useHistoryColumns(t);

    React.useEffect(() => {
        setArrayIds(selectedProject.map((el) => el.Id));
    }, [selectedProject]);

    return (
        <React.Fragment>
            <Modal
                centered
                backdrop="static"
                fade={false}
                scrollable
                className="modal-wrapper__clz"
                isOpen={isModalOpened}
            >
                <ModalHeader
                    toggle={() => {
                        setIsModalOpened!(!isModalOpened);
                        setIsCreatedProject(false);
                        setSelectedRows([]);
                    }}
                    className="dev_icn_HSclose"
                >
                    <StyledH2 className="dev_txt_HStitleHistory">
                        {capitalize(t(HISTORY_I18N_KEY.HISTORICAL))}
                    </StyledH2>
                </ModalHeader>

                <ModalBody>
                    <div
                        className={`${classnames("title__clz", {
                            "not-allowed-icon__clz": selectedProject.length > 1,
                        })}`}
                    >
                        <CustomColumnDisplay
                            text={`${t(HISTORY_I18N_KEY.DESIGNATION)}:${
                                selectedProject.length > 1
                                    ? null
                                    : data?.data !== undefined &&
                                      data?.data.length > 0
                                    ? data?.data![0][
                                          t(HISTORY_I18N_KEY.DESIGNATION)
                                      ]
                                    : ""
                            }`}
                        />
                    </div>

                    <DynamicTable
                        url={url}
                        canResize
                        actionColumn={ActionColumn}
                        showGlobalFilter
                        requestHeader={{
                            "Accept-Language": i18nextLng,
                            ...getAuthHeader,
                        }}
                        showFilter
                        setLocalFilterActive={setLocalFilterActive}
                        filterActive={filterActive}
                        setDataIsUpdated={setDataIsUpdated}
                        dataIsUpdated={dataIsUpdated}
                        elevationTable={1}
                        minHeight="500px"
                        maxHeight="500px"
                        name="historyProject"
                        arrayOfCustomColumns={arrayOfCustomColumns}
                        setData={setData}
                    />
                </ModalBody>
                <ModalFooter className="border-top-0">
                    <CustomMainColorButton
                        variant="primary"
                        className="fed_btn_HSclose"
                        onClick={() => {
                            setIsModalOpened(!isModalOpened);
                            setIsCreatedProject(false);
                            setSelectedRows([]);
                        }}
                        rounded
                    >
                        {t(HISTORY_I18N_KEY.CLOSE)}
                    </CustomMainColorButton>
                </ModalFooter>
            </Modal>
        </React.Fragment>
    );
}
